// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import { Plus, Trash2, Edit2, ChevronDown, ChevronUp } from "lucide-react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// import ApiUrl from "../Environment/ApiUrl";

// const AddPurchases = () => {
//   const navigate = useNavigate();
//   const [dealers, setDealers] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [categoryTableData, setCategoryTableData] = useState([]);
//   const [expandedCategories, setExpandedCategories] = useState({});
//   const [quantities, setQuantities] = useState({});

//   // State for purchase data
//   const [purchaseData, setPurchaseData] = useState({
//     purchaseId: "",
//     purchaseDate: new Date().toISOString().split("T")[0],

//     mobile_no: "",
//     dealerName: "",
//     subTotal: 0,
//     gstAmount: 0,
//     netTotal: 0,
//     paidAmount: 0,
//     balance: 0,
//   });

//   // State for purchase items
//   const [purchaseItems, setPurchaseItems] = useState([]);
//   const [showAddRow, setShowAddRow] = useState(true);
//   const [editIndex, setEditIndex] = useState(null);
//   const [purchaseItemForm, setPurchaseItemForm] = useState({
//     HSN_code: "",
//     branch_name: "Default Branch",
//     brand_name: "",
//     type: "",
//     tyre_size: "",
//     Quantity: "",
//     purchase_rate: "",
//     Gst: "",
//     Category: "",
//     Subcategory: "",
//     status: "In Stock",
//     purchase_quantity: "",
//     purchase_gst: "",
//     Mrp: "",
//   });

//   // State for form validation errors
//   const [formErrors, setFormErrors] = useState({
//     brand_name: "",
//     Quantity: "",
//     purchase_rate: "",
//     Gst: "",
//     purchaseDate: "",
//     purchase_quantity: "",
//     purchase_gst: "",
//     Mrp: "",
//   });

//   // State for payment history
//   const [paymentHistory, setPaymentHistory] = useState([]);
//   const [showPaymentModal, setShowPaymentModal] = useState(false);
//   const [paymentForm, setPaymentForm] = useState({
//     date: new Date().toISOString().split("T")[0],
//     pay_type: "",
//     amount: "",
//   });
//   const [paymentEditIndex, setPaymentEditIndex] = useState(null);

//   // State for product modal
//   const [showModal, setShowModal] = useState(false);
//   const [productData, setProductData] = useState({
//     HSN_code: "",
//     Category: "",
//     Subcategory: "",
//     branch_name: "Default Branch",
//     brand_name: "",
//     type: "",
//     tyre_size: "",
//     rate: "",
//     gst: "",
//     status: "Active",
//     Mrp: "",
//   });

//   // Validate purchase item form
//   const validatePurchaseItemForm = () => {
//     const errors = {};
//     if (!purchaseItemForm.brand_name) errors.brand_name = "Brand is required";
//     if (!purchaseItemForm.Quantity) errors.Quantity = "Quantity is required";
//     else if (
//       isNaN(purchaseItemForm.Quantity) ||
//       Number(purchaseItemForm.Quantity) <= 0
//     )
//       errors.Quantity = "Quantity must be a positive number";
//     if (!purchaseItemForm.purchase_rate)
//       errors.purchase_rate = "Purchase Rate is required";
//     else if (
//       isNaN(purchaseItemForm.purchase_rate) ||
//       Number(purchaseItemForm.purchase_rate) <= 0
//     )
//       errors.purchase_rate = "Purchase Rate must be a positive number";
//     if (!purchaseItemForm.Gst) errors.Gst = "GST is required";
//     else if (isNaN(purchaseItemForm.Gst) || Number(purchaseItemForm.Gst) < 0)
//       errors.Gst = "GST must be a non-negative number";
//     if (!purchaseItemForm.purchase_quantity)
//       errors.purchase_quantity = "Purchase Quantity is required";
//     else if (
//       isNaN(purchaseItemForm.purchase_quantity) ||
//       Number(purchaseItemForm.purchase_quantity) <= 0
//     )
//       errors.purchase_quantity = "Purchase Quantity must be a positive number";
//     if (!purchaseItemForm.purchase_gst)
//       errors.purchase_gst = "Purchase GST is required";
//     else if (
//       isNaN(purchaseItemForm.purchase_gst) ||
//       Number(purchaseItemForm.purchase_gst) < 0
//     )
//       errors.purchase_gst = "Purchase GST must be a non-negative number";
//     if (!purchaseItemForm.Mrp) errors.Mrp = "MRP is required";
//     else if (isNaN(purchaseItemForm.Mrp) || Number(purchaseItemForm.Mrp) <= 0)
//       errors.Mrp = "MRP must be a positive number";
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   // Calculate totals
//   const calculateTotals = useCallback((items, payments) => {
//     const subTotal = items.reduce((sum, item) => {
//       const quantity = Number(item.purchase_quantity) || 0;
//       const rate = Number(item.purchase_rate) || 0;
//       return sum + quantity * rate;
//     }, 0);

//     const gstAmount = items.reduce((sum, item) => {
//       const quantity = Number(item.purchase_quantity) || 0;
//       const rate = Number(item.purchase_rate) || 0;
//       const gst = Number(item.purchase_gst) || 0;
//       return sum + (quantity * rate * gst) / 100;
//     }, 0);

//     const netTotal = subTotal + gstAmount;
//     const paidAmount = payments.reduce(
//       (sum, payment) => sum + (Number(payment.amount) || 0),
//       0
//     );
//     const paymentStatus =
//       paidAmount >= netTotal ? "PAID" : paidAmount > 0 ? "PARTIAL" : "UNPAID";

//     setPurchaseData((prev) => ({
//       ...prev,
//       subTotal: subTotal.toFixed(2),
//       gstAmount: gstAmount.toFixed(2),
//       netTotal: netTotal.toFixed(2),
//       paidAmount: paidAmount.toFixed(2),
//       paymentStatus,
//     }));
//   }, []);

//   // Fetch initial data
//   useEffect(() => {
//     const fetchData = async () => {
//       setIsLoading(true);
//       try {
//         const productResponse = await axios.get(`${ApiUrl}/product_data.php`);
//         let fetchedData = Array.isArray(productResponse.data.data)
//           ? productResponse.data.data
//           : [];
//         const requestedProduct = {
//           id: `custom_${Date.now()}`,
//           HSN_code: "HSN001",
//           Category: "LT",
//           Subcategory: "Pick up Radils",
//           branch_name: "Default Branch",
//           brand_name: "MRF",
//           type: "Tubeless",
//           tyre_size: "100/90-17",
//           status: "Inactive",
//           rate: "1000",
//           gst: "18",
//           Mrp: "1200",
//         };
//         const exists = fetchedData.some(
//           (item) =>
//             item.brand_name === requestedProduct.brand_name &&
//             item.tyre_size === requestedProduct.tyre_size
//         );
//         if (!exists) {
//           fetchedData = [...fetchedData, requestedProduct];
//         }
//         setProducts(fetchedData);

//         const categoriesMap = {};
//         fetchedData.forEach((item) => {
//           if (!item.Category) return;
//           if (!categoriesMap[item.Category]) {
//             categoriesMap[item.Category] = new Set();
//           }
//           if (item.Subcategory && typeof item.Subcategory === "string") {
//             item.Subcategory.split(",")
//               .map((subCat) => subCat.trim())
//               .filter((subCat) => subCat.length > 0)
//               .forEach((subCat) => categoriesMap[item.Category].add(subCat));
//           }
//         });
//         if (!categoriesMap["LT"]) {
//           categoriesMap["LT"] = new Set(["Pick up Radils"]);
//         } else {
//           categoriesMap["LT"].add("Pick up Radils");
//         }
//         const transformedData = Object.keys(categoriesMap).map((category) => ({
//           Category: category,
//           SubCategories: Array.from(categoriesMap[category]),
//         }));
//         setCategoryTableData(transformedData);

//         const initialQuantities = {};
//         fetchedData.forEach((item) => {
//           initialQuantities[item.id] = 0;
//         });
//         setQuantities(initialQuantities);

//         const dealerResponse = await axios.get(`${ApiUrl}/dealer_data.php`);
//         const dealerData = Array.isArray(dealerResponse.data.data)
//           ? dealerResponse.data.data
//           : Array.isArray(dealerResponse.data)
//             ? dealerResponse.data
//             : [];
//         setDealers(dealerData);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         setError("Error fetching data: " + error.message);
//         setDealers([]);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   const fetchNextProductId = async () => {
//     try {
//       setIsLoading(true);
//       const response = await axios.get(
//         `${ApiUrl}/product_data.php/generate-product-code`
//       );
//       if (!response.data || !response.data.HSN_code) {
//         throw new Error("Invalid response structure: HSN_code not found");
//       }
//       setProductData((prev) => ({
//         ...prev,
//         HSN_code: response.data.HSN_code,
//       }));
//       setError(null);
//     } catch (error) {
//       console.error(
//         "Error fetching product ID:",
//         error.message,
//         error.response?.data
//       );
//       setError(
//         error.response?.data?.message ||
//         "Failed to fetch product ID. Please try again."
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const toggleCategory = (category) => {
//     setExpandedCategories((prev) => ({
//       ...prev,
//       [category]: !prev[category],
//     }));
//   };

//   const handleQuantityChange = useCallback(
//     (item, action) => {
//       setQuantities((prev) => {
//         const newQuantities = { ...prev };
//         const itemKey = item.id;
//         const currentQuantity = newQuantities[itemKey] || 0;
//         const newQuantity =
//           action === "increase"
//             ? currentQuantity + 1
//             : currentQuantity > 0
//               ? currentQuantity - 1
//               : 0;

//         newQuantities[itemKey] = newQuantity;

//         const newItem = {
//           id: item.id,
//           purchaseId: purchaseData.purchaseId,
//           purchaseRefId: Date.now().toString(),
//           HSN_code: item.HSN_code,
//           branch_name: item.branch_name || "Default Branch",
//           brand_name: item.brand_name,
//           type: item.type,
//           tyre_size: item.tyre_size,
//           status: item.status,
//           Category: item.Category,
//           Subcategory: item.Subcategory,
//           Quantity: newQuantity,
//           purchase_rate: Number(item.rate) || 0,
//           Gst: Number(item.gst) || 0,
//           purchase_quantity: newQuantity,
//           purchase_gst: Number(item.gst) || 0,
//           Mrp: Number(item.Mrp) || 0,
//         };

//         setPurchaseItems((prevItems) => {
//           const existingItemIndex = prevItems.findIndex(
//             (pi) => pi.id === item.id
//           );
//           let updatedItems;
//           if (newQuantity === 0) {
//             updatedItems = prevItems.filter((_, i) => i !== existingItemIndex);
//           } else if (existingItemIndex >= 0) {
//             updatedItems = [...prevItems];
//             updatedItems[existingItemIndex] = newItem;
//           } else {
//             updatedItems = [...prevItems, newItem];
//           }
//           calculateTotals(updatedItems, paymentHistory);
//           return updatedItems;
//         });

//         return newQuantities;
//       });
//     },
//     [calculateTotals, purchaseData.purchaseId, paymentHistory]
//   );

//   const handlePurchaseDataChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "dealerId") {
//       const selectedDealer = dealers.find(
//         (dealer) => dealer.dealer_id === value
//       );
//       setPurchaseData((prev) => ({
//         ...prev,
//         dealerName: selectedDealer ? selectedDealer.dealer_name : "",
//       }));
//     } else {
//       setPurchaseData((prev) => ({ ...prev, [name]: value }));
//       if (name === "purchaseDate") {
//         setFormErrors((prev) => ({
//           ...prev,
//           purchaseDate: !value ? "Purchase date is required" : "",
//         }));
//       }
//     }
//   };

//   const handlePurchaseItemChange = (e) => {
//     const { name, value } = e.target;
//     setPurchaseItemForm((prev) => ({ ...prev, [name]: value }));
//     setFormErrors((prev) => ({
//       ...prev,
//       [name]: !value
//         ? `${name === "brand_name" ? "Brand" : name} is required`
//         : isNaN(value) ||
//           Number(value) <= (name === "Gst" || name === "purchase_gst" ? -1 : 0)
//           ? `${name} must be a ${name === "Gst" || name === "purchase_gst"
//             ? "non-negative"
//             : "positive"
//           } number`
//           : "",
//     }));
//     if (name === "brand_name") {
//       const selectedProduct = products.find(
//         (product) => product.brand_name === value
//       );
//       setPurchaseItemForm((prev) => ({
//         ...prev,
//         branch_name: "Default Branch",
//         brand_name: value,
//         tyre_size: selectedProduct ? selectedProduct.tyre_size : "",
//         type: selectedProduct ? selectedProduct.type : "",
//         purchase_rate: selectedProduct ? selectedProduct.rate : "",
//         Gst: selectedProduct ? selectedProduct.gst : "",
//         HSN_code: selectedProduct ? selectedProduct.HSN_code : "",
//         Category: selectedProduct ? selectedProduct.Category : "",
//         Subcategory: selectedProduct ? selectedProduct.Subcategory : "",
//         purchase_quantity: "",
//         purchase_gst: selectedProduct ? selectedProduct.gst : "",
//         Mrp: selectedProduct ? selectedProduct.Mrp : "",
//       }));
//       setFormErrors((prev) => ({
//         ...prev,
//         brand_name: !value ? "Brand is required" : "",
//       }));
//     }
//   };

//   const handleAddPurchaseItem = () => {
//     if (!validatePurchaseItemForm()) {
//       setShowAddRow(true);
//       setError("Please fill all item fields correctly");
//       return;
//     }

//     const newItem = {
//       ...purchaseItemForm,
//       id:
//         editIndex !== null
//           ? purchaseItems[editIndex].id
//           : Date.now().toString(),
//       purchaseId: purchaseData.purchaseId,
//       purchaseRefId: Date.now().toString(),
//       Quantity: Number(purchaseItemForm.Quantity),
//       purchase_rate: Number(purchaseItemForm.purchase_rate) || 0,
//       Gst: Number(purchaseItemForm.Gst) || 0,
//       purchase_quantity: Number(purchaseItemForm.purchase_quantity) || 0,
//       purchase_gst: Number(purchaseItemForm.purchase_gst) || 0,
//       Mrp: Number(purchaseItemForm.Mrp) || 0,
//     };

//     let updatedItems;
//     if (editIndex !== null) {
//       updatedItems = [...purchaseItems];
//       updatedItems[editIndex] = newItem;
//       setEditIndex(null);
//     } else {
//       updatedItems = [...purchaseItems, newItem];
//     }

//     setPurchaseItems(updatedItems);
//     calculateTotals(updatedItems, paymentHistory);
//     resetPurchaseItemForm();
//     setShowAddRow(false);
//   };

//   const resetPurchaseItemForm = () => {
//     setPurchaseItemForm({
//       HSN_code: "",
//       branch_name: "Default Branch",
//       brand_name: "",
//       type: "",
//       tyre_size: "",
//       Quantity: "",
//       purchase_rate: "",
//       Gst: "",
//       Category: "",
//       Subcategory: "",
//       status: "In Stock",
//       purchase_quantity: "",
//       purchase_gst: "",
//       Mrp: "",
//     });
//     setFormErrors({
//       brand_name: "",
//       Quantity: "",
//       purchase_rate: "",
//       Gst: "",
//       purchaseDate: "",
//       purchase_quantity: "",
//       purchase_gst: "",
//       Mrp: "",
//     });
//     setShowAddRow(true);
//   };

//   const handleEditPurchaseItemField = (index, field, value) => {
//     const updatedItems = [...purchaseItems];
//     updatedItems[index] = { ...updatedItems[index], [field]: value };

//     // Validate the edited field
//     const errors = {};
//     if (field === "Quantity") {
//       if (!value) errors.Quantity = "Quantity is required";
//       else if (isNaN(value) || Number(value) <= 0)
//         errors.Quantity = "Quantity must be a positive number";
//     }
//     if (field === "purchase_rate") {
//       if (!value) errors.purchase_rate = "Purchase Rate is required";
//       else if (isNaN(value) || Number(value) <= 0)
//         errors.purchase_rate = "Purchase Rate must be a positive number";
//     }
//     if (field === "Gst") {
//       if (!value) errors.Gst = "GST is required";
//       else if (isNaN(value) || Number(value) < 0)
//         errors.Gst = "GST must be a non-negative number";
//     }
//     if (field === "purchase_quantity") {
//       if (!value) errors.purchase_quantity = "Purchase Quantity is required";
//       else if (isNaN(value) || Number(value) <= 0)
//         errors.purchase_quantity =
//           "Purchase Quantity must be a positive number";
//     }
//     if (field === "purchase_gst") {
//       if (!value) errors.purchase_gst = "Purchase GST is required";
//       else if (isNaN(value) || Number(value) < 0)
//         errors.purchase_gst = "Purchase GST must be a non-negative number";
//     }
//     if (field === "Mrp") {
//       if (!value) errors.Mrp = "MRP is required";
//       else if (isNaN(value) || Number(value) <= 0)
//         errors.Mrp = "MRP must be a positive number";
//     }
//     setFormErrors(errors);

//     if (Object.keys(errors).length === 0) {
//       setPurchaseItems(updatedItems);
//       calculateTotals(updatedItems, paymentHistory);
//     }
//   };

//   const handleEditItem = (index) => {
//     setPurchaseItemForm(purchaseItems[index]);
//     setEditIndex(index);
//     setShowAddRow(true);
//     setFormErrors({
//       brand_name: "",
//       Quantity: "",
//       purchase_rate: "",
//       Gst: "",
//       purchaseDate: "",
//       purchase_quantity: "",
//       purchase_gst: "",
//       Mrp: "",
//     });
//   };

//   const handleDeleteItem = (index) => {
//     const updatedItems = purchaseItems.filter((_, i) => i !== index);
//     setPurchaseItems(updatedItems);
//     calculateTotals(updatedItems, paymentHistory);
//     setQuantities((prev) => ({
//       ...prev,
//       [purchaseItems[index].id]: 0,
//     }));
//   };

//   const handlePaymentChange = (e) => {
//     const { name, value } = e.target;
//     setPaymentForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleAddPayment = () => {
//     if (!paymentForm.pay_type || !paymentForm.amount) {
//       setError("Please fill all payment fields");
//       return;
//     }

//     if (isNaN(paymentForm.amount) || Number(paymentForm.amount) <= 0) {
//       setError("Payment amount must be a valid positive number");
//       return;
//     }

//     const newPayment = {
//       ...paymentForm,
//       id:
//         paymentEditIndex !== null
//           ? paymentHistory[paymentEditIndex].id
//           : Date.now().toString(),
//       amount: Number(paymentForm.amount),
//     };

//     let updatedHistory;
//     if (paymentEditIndex !== null) {
//       updatedHistory = [...paymentHistory];
//       updatedHistory[paymentEditIndex] = newPayment;
//       setPaymentEditIndex(null);
//     } else {
//       updatedHistory = [...paymentHistory, newPayment];
//     }

//     setPaymentHistory(updatedHistory);
//     calculateTotals(purchaseItems, updatedHistory);
//     resetPaymentForm();

//     toast.success("Payment added successfully!");
//   };

//   const resetPaymentForm = () => {
//     setPaymentForm({
//       date: new Date().toISOString().split("T")[0],
//       pay_type: "",
//       amount: "",
//     });
//   };

//   const handleEditPayment = (index) => {
//     setPaymentForm(paymentHistory[index]);
//     setPaymentEditIndex(index);
//   };

//   const handleDeletePayment = (index) => {
//     const updatedPayments = paymentHistory.filter((_, i) => i !== index);
//     setPaymentHistory(updatedPayments);
//     calculateTotals(purchaseItems, updatedPayments);
//     toast.success("Payment deleted successfully!");
//   };

//   const handleCancel = () => {
//     navigate("/purchases");
//   };



//   const handleSubmit = async () => {
//     // Validate all required fields
//     const errors = {};
//     if (!purchaseData.purchaseId) errors.purchaseId = "Purchase ID is required";
//     if (!purchaseData.purchaseDate)
//       errors.purchaseDate = "Purchase date is required";
//     if (!purchaseData.dealerName) errors.dealerName = "Dealer name is required";
//     if (!purchaseData.subTotal) errors.subTotal = "Sub total is required";
//     if (!purchaseData.gstAmount) errors.gstAmount = "GST amount is required";
//     if (!purchaseData.netTotal) errors.netTotal = "Net total is required";
//     if (!purchaseData.paidAmount) errors.paidAmount = "Paid amount is required";
//     if (!purchaseData.paymentStatus)
//       errors.paymentStatus = "Payment status is required";
//     if (purchaseItems.length === 0)
//       errors.purchaseItems = "At least one purchase item is required";

//     if (Object.keys(errors).length > 0) {
//       setError(Object.values(errors).join(", "));
//       return;
//     }

//     // Ensure purchaseDate is in the correct format
//     let formattedPurchaseDate;
//     try {
//       formattedPurchaseDate = new Date(purchaseData.purchaseDate)
//         .toISOString()
//         .split("T")[0];
//       if (!formattedPurchaseDate || formattedPurchaseDate === "Invalid Date") {
//         setError("Invalid purchase date format");
//         setFormErrors((prev) => ({
//           ...prev,
//           purchaseDate: "Invalid purchase date format",
//         }));
//         return;
//       }
//     } catch (error) {
//       setError("Invalid purchase date format");
//       setFormErrors((prev) => ({
//         ...prev,
//         purchaseDate: "Invalid purchase date format",
//       }));
//       return;
//     }

//     // Validate purchase items
//     for (let i = 0; i < purchaseItems.length; i++) {
//       const item = purchaseItems[i];
//       const itemErrors = {};

//       if (!item.HSN_code)
//         itemErrors.HSN_code = `Item ${i + 1}: HSN code is required`;
//       if (!item.brand_name)
//         itemErrors.brand_name = `Item ${i + 1}: Brand name is required`;
//       if (!item.type) itemErrors.type = `Item ${i + 1}: Type is required`;
//       if (!item.tyre_size)
//         itemErrors.tyre_size = `Item ${i + 1}: Tyre size is required`;
//       if (!item.status) itemErrors.status = `Item ${i + 1}: Status is required`;
//       if (!item.Category)
//         itemErrors.Category = `Item ${i + 1}: Category is required`;
//       if (!item.Subcategory)
//         itemErrors.Subcategory = `Item ${i + 1}: Subcategory is required`;
//       if (!item.purchase_quantity)
//         itemErrors.purchase_quantity = `Item ${i + 1}: Purchase Quantity is required`;
//       if (!item.purchase_gst)
//         itemErrors.purchase_gst = `Item ${i + 1}: Purchase GST is required`;
//       if (!item.purchase_rate)
//         itemErrors.purchase_rate = `Item ${i + 1}: Purchase Rate is required`;
//       if (!item.Mrp) itemErrors.Mrp = `Item ${i + 1}: MRP is required`;

//       if (Object.keys(itemErrors).length > 0) {
//         setError(Object.values(itemErrors).join(", "));
//         return;
//       }
//     }

//     // Create payload for purchase_data.php
//     const purchasePayload = {
//       purchaseId: purchaseData.purchaseId,
//       purchaseDate: formattedPurchaseDate,
//       purchaseType: purchaseData.purchaseType,
//       dealerName: purchaseData.dealerName,
//       subTotal: parseFloat(purchaseData.subTotal) || 0,
//       gstAmount: parseFloat(purchaseData.gstAmount) || 0,
//       netTotal: parseFloat(purchaseData.netTotal) || 0,
//       paidAmount: parseFloat(purchaseData.paidAmount) || 0,
//       paymentStatus: purchaseData.paymentStatus,
//       purchaseItems: purchaseItems.map((item) => ({
//         HSN_code: item.HSN_code,
//         brand_name: item.brand_name,
//         type: item.type,
//         tyre_size: item.tyre_size,
//         status: item.status,
//         Category: item.Category,
//         Subcategory: item.Subcategory,
//         Quantity: item.Quantity || 0,
//         purchase_rate: item.purchase_rate || 0,
//         Gst: item.Gst || 0,
//         purchase_quantity: item.purchase_quantity || 0,
//         purchase_gst: item.purchase_gst || 0,
//         Mrp: item.Mrp || 0,
//       })),
//       purchasePaymentHistory: paymentHistory.map((payment) => ({
//         date: payment.date,
//         pay_type: payment.pay_type,
//         amount: parseFloat(payment.amount) || 0,
//       })),
//     };

//     try {
//       setIsLoading(true);

//       // Post to purchase_data.php
//       const purchaseResponse = await axios.post(
//         `${ApiUrl}/purchase_data.php`,
//         purchasePayload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       // Post to stockdata.php for each purchase item
//       for (const item of purchaseItems) {
//         const stockPayload = {
//           hsn_code: item.HSN_code,
//           type: item.type,
//           tyre_size: item.tyre_size,
//           category: item.Category,
//           subcategory: item.Subcategory,
//           purchase_rate: parseFloat(item.purchase_rate) || 0,
//           avg_purchase_rate: parseFloat(item.purchase_rate) || 0,
//           mrp: item.Mrp || "0",
//           available_quantity: item.purchase_quantity || 0,
//           total_purchase_quantity: item.purchase_quantity || 0,
//           sold_quantity: 0,
//           total_purchases: 1,
//         };

//         const stockResponse = await axios.post(
//           `http://localhost/manuel_tyre/stockdata.php`,
//           stockPayload,
//           {
//             headers: {
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (stockResponse.data.status !== true) {
//           throw new Error(`Failed to update stock for item ${item.HSN_code}: ${stockResponse.data.message}`);
//         }
//       }

//       toast.success("Purchase and stock data added successfully!");
//       navigate("/purchases");
//     } catch (error) {
//       console.error("Error saving data:", error);
//       if (error.response && error.response.data) {
//         setError(
//           "Error saving data: " +
//           (error.response.data.message || error.message)
//         );
//       } else {
//         setError("Error saving data: " + error.message);
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };
//   // const handlePrint = () => {
//   //   if (purchaseData.purchaseId) {
//   //     navigate(`/purchase_bill/${purchaseData.purchaseId}`);
//   //   } else {
//   //     toast.error("Cannot print: Purchase ID is not available");
//   //   }
//   // };

//   const handleProductSubmit = async (e) => {
//     e.preventDefault();
//     if (
//       !productData.Category ||
//       !productData.Subcategory ||
//       !productData.rate ||
//       !productData.gst ||
//       !productData.Mrp
//     ) {
//       setError("Please fill all required product fields");
//       return;
//     }

//     if (
//       isNaN(productData.rate) ||
//       isNaN(productData.gst) ||
//       Number(productData.rate) <= 0 ||
//       Number(productData.gst) < 0 ||
//       isNaN(productData.Mrp) ||
//       Number(productData.Mrp) <= 0
//     ) {
//       setError("Rate, GST, and MRP must be valid positive numbers");
//       return;
//     }

//     try {
//       setIsLoading(true);
//       const formData = {
//         HSN_code: productData.HSN_code,
//         Category: productData.Category,
//         Subcategory: productData.Subcategory,
//         branch_name: productData.branch_name,
//         brand_name: productData.brand_name,
//         type: productData.type,
//         tyre_size: productData.tyre_size,
//         rate: Number(productData.rate),
//         gst: Number(productData.gst),
//         status: productData.status,
//         Mrp: Number(productData.Mrp),
//       };
//       await axios.post(`${ApiUrl}/product_data.php`, formData);
//       const newProduct = { ...formData, id: Date.now().toString() };
//       setProducts((prev) => [...prev, newProduct]);
//       const updatedCategories = [...categoryTableData];
//       const categoryIndex = updatedCategories.findIndex(
//         (cat) => cat.Category === formData.Category
//       );
//       if (categoryIndex >= 0) {
//         if (
//           !updatedCategories[categoryIndex].SubCategories.includes(
//             formData.Subcategory
//           )
//         ) {
//           updatedCategories[categoryIndex].SubCategories.push(
//             formData.Subcategory
//           );
//         }
//       } else {
//         updatedCategories.push({
//           Category: formData.Category,
//           SubCategories: [formData.Subcategory],
//         });
//       }
//       setCategoryTableData(updatedCategories);
//       setQuantities((prev) => ({ ...prev, [newProduct.id]: 0 }));
//       fetchNextProductId();
//       setShowModal(false);
//       setPurchaseItemForm((prev) => ({
//         ...prev,
//         HSN_code: formData.HSN_code,
//         branch_name: formData.branch_name,
//         brand_name: formData.brand_name,
//         type: formData.type,
//         tyre_size: formData.tyre_size,
//         purchase_rate: formData.rate,
//         Gst: formData.gst,
//         Category: formData.Category,
//         Subcategory: formData.Subcategory,
//         purchase_quantity: "",
//         purchase_gst: formData.gst,
//         Mrp: formData.Mrp,
//       }));
//       setError(null);
//     } catch (error) {
//       console.error("Error adding product:", error);
//       setError("Error adding product: " + error.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const [searchQuery, setSearchQuery] = useState("");

//   // Filter products and categories based on search query
//   const filteredData = useMemo(() => {
//     if (!searchQuery.trim()) {
//       return categoryTableData;
//     }

//     const query = searchQuery.toLowerCase().trim();
//     const filtered = [];

//     categoryTableData.forEach((category) => {
//       const categoryMatches = category.Category.toLowerCase().includes(query);

//       const matchingProducts = products.filter((item) => {
//         if (item.Category !== category.Category) return false;

//         return (
//           item.brand_name?.toLowerCase().includes(query) ||
//           item.type?.toLowerCase().includes(query) ||
//           item.tyre_size?.toLowerCase().includes(query) ||
//           item.Subcategory?.toLowerCase().includes(query) ||
//           item.Category?.toLowerCase().includes(query)
//         );
//       });

//       if (categoryMatches || matchingProducts.length > 0) {
//         const matchingSubCategories = category.SubCategories.filter(
//           (subCat) => {
//             const subCatMatches = subCat.toLowerCase().includes(query);
//             const hasMatchingProducts = matchingProducts.some((product) =>
//               product.Subcategory?.toLowerCase().includes(subCat.toLowerCase())
//             );
//             return subCatMatches || hasMatchingProducts || categoryMatches;
//           }
//         );

//         if (matchingSubCategories.length > 0) {
//           filtered.push({
//             ...category,
//             SubCategories: matchingSubCategories,
//           });
//         }
//       }
//     });

//     return filtered;
//   }, [categoryTableData, products, searchQuery]);

//   // Filter products for display based on search
//   const getFilteredProducts = (categoryName) => {
//     if (!searchQuery.trim()) {
//       return products.filter((item) => item.Category === categoryName);
//     }

//     const query = searchQuery.toLowerCase().trim();
//     return products.filter((item) => {
//       if (item.Category !== categoryName) return false;

//       return (
//         item.brand_name?.toLowerCase().includes(query) ||
//         item.type?.toLowerCase().includes(query) ||
//         item.tyre_size?.toLowerCase().includes(query) ||
//         item.Subcategory?.toLowerCase().includes(query) ||
//         item.Category?.toLowerCase().includes(query)
//       );
//     });
//   };

//   // Auto-expand categories when searching
//   useEffect(() => {
//     if (searchQuery.trim()) {
//       const newExpandedCategories = {};
//       filteredData.forEach((category) => {
//         newExpandedCategories[category.Category] = true;
//       });
//       setExpandedCategories(newExpandedCategories);
//     }
//   }, [searchQuery, filteredData]);

//   // Clear search function
//   const clearSearch = () => {
//     setSearchQuery("");
//   };

//   return (
//     <div className="bg-white font-sans overflow-x-hidden overflow-y-hidden">
//       <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         hideProgressBar={false}
//         closeOnClick
//         pauseOnHover
//       />

//       {error && (
//         <div className="alert alert-danger mx-4" role="alert">
//           {error}
//         </div>
//       )}
//       {isLoading && <div className="text-center">Loading...</div>}
//       <h2 className="m-0 fs-5 fw-semibold text-dark mx-4 mb-3">Add Purchase</h2>
//       <div className="row g-3">
//         {/* Product List */}
//         <div className="col-lg-3">
//           <div className="card p-3 h-100">
//             <div className="mb-4 d-flex justify-content-between align-items-center">
//               <h5 className="mb-0">Product List</h5>
//               <button
//                 className="btn btn-primary"
//                 onClick={() => {
//                   setShowModal(true);
//                   fetchNextProductId();
//                 }}
//               >
//                 <Plus size={16} />
//               </button>
//             </div>

//             <div className="mb-3">
//               <label htmlFor="searchInput" className="form-label">
//                 Search Products
//               </label>
//               <div className="input-group">
//                 <input
//                   type="text"
//                   id="searchInput"
//                   className="form-control"
//                   placeholder="Search by category, brand, type, size..."
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                 />
//                 {searchQuery && (
//                   <button
//                     className="btn btn-outline-secondary"
//                     type="button"
//                     onClick={clearSearch}
//                     title="Clear search"
//                   >
//                     ×
//                   </button>
//                 )}
//               </div>
//               {searchQuery && (
//                 <small className="text-muted">
//                   Showing results for "{searchQuery}" ({filteredData.length}{" "}
//                   categories found)
//                 </small>
//               )}
//             </div>

//             <div className="table-responsive">
//               <table
//                 className="table table-bordered table-sm"
//                 style={{ fontSize: "13px" }}
//               >
//                 <thead>
//                   <tr>
//                     <th></th>
//                     <th>Products</th>

//                     <th>Qty</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredData.map((category) => (
//                     <React.Fragment key={category.Category}>
//                       <tr>
//                         <td>
//                           <button
//                             className="btn btn-sm btn-outline-secondary"
//                             onClick={() => toggleCategory(category.Category)}
//                           >
//                             {expandedCategories[category.Category] ? (
//                               <ChevronUp size={16} />
//                             ) : (
//                               <ChevronDown size={16} />
//                             )}
//                           </button>
//                         </td>
//                         <td colSpan="4" className="fw-bold">
//                           {category.Category}
//                         </td>
//                       </tr>
//                       {expandedCategories[category.Category] &&
//                         getFilteredProducts(category.Category).map(
//                           (item, index) => (
//                             <tr key={item.id}>
//                               <td></td>
//                               <td>
//                                 {item.brand_name} - {item.type || "N/A"} -{" "}
//                                 {item.tyre_size || "N/A"}
//                               </td>
//                               <td>
//                                 <div className="d-flex align-items-center">
//                                   <button
//                                     className="btn btn-sm btn-outline-secondary me-2"
//                                     onClick={() =>
//                                       handleQuantityChange(item, "decrease")
//                                     }
//                                     disabled={quantities[item.id] === 0}
//                                   >
//                                     -
//                                   </button>
//                                   <span>{quantities[item.id]}</span>
//                                   <button
//                                     className="btn btn-sm btn-outline-secondary ms-2"
//                                     onClick={() =>
//                                       handleQuantityChange(item, "increase")
//                                     }
//                                   >
//                                     +
//                                   </button>
//                                 </div>
//                               </td>
//                             </tr>
//                           )
//                         )}
//                     </React.Fragment>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>

//         {/* Purchase Items Table */}
//         <div className="col-lg-6">
//           <div className="card border h-100">
//             <div className="card-body p-0">
//               <h5 className="p-2">Purchase Items List</h5>
//               <div className="table-responsive">
//                 <table className="table table-hover mb-0 text-center">
//                   <thead>
//                     <tr style={{ backgroundColor: "#d3d3d3" }}>
//                       <th className="p-3 text-start fw-semibold small border-bottom">
//                         S.No
//                       </th>
//                       <th className="p-3 text-start fw-semibold small border-bottom">
//                         Items
//                       </th>
//                       <th className="p-3 text-start fw-semibold small border-bottom">
//                         Pur Rate
//                       </th>
//                       <th className="p-3 text-start fw-semibold small border-bottom">
//                         Qty
//                       </th>
//                       <th className="p-3 text-start fw-semibold small border-bottom">
//                         GST (%)
//                       </th>
//                       <th className="p-3 text-start fw-semibold small border-bottom">
//                         MRP
//                       </th>
//                       <th className="p-3 text-start fw-semibold small border-bottom">
//                         Action
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {purchaseItems.length > 0 ? (
//                       purchaseItems.map((item, index) => (
//                         <React.Fragment key={item.id}>
//                           <tr style={{ fontSize: "15px", fontWeight: "400" }}>
//                             <td>{index + 1}</td>
//                             <td>{item.brand_name}</td>
//                             <td>
//                               <input
//                                 type="tel"
//                                 className={`form-control form-control-sm ${formErrors.purchase_rate
//                                   ? "border-danger"
//                                   : ""
//                                   }`}
//                                 value={item.purchase_rate}
//                                 onChange={(e) =>
//                                   handleEditPurchaseItemField(
//                                     index,
//                                     "purchase_rate",
//                                     e.target.value
//                                   )
//                                 }
//                                 style={{ width: "100px" }}
//                               />
//                             </td>
//                             <td>
//                               <input
//                                 type="tel"
//                                 className={`form-control form-control-sm ${formErrors.purchase_quantity
//                                   ? "border-danger"
//                                   : ""
//                                   }`}
//                                 value={item.purchase_quantity}
//                                 onChange={(e) =>
//                                   handleEditPurchaseItemField(
//                                     index,
//                                     "purchase_quantity",
//                                     e.target.value
//                                   )
//                                 }
//                                 style={{ width: "50px" }}
//                               />
//                             </td>
//                             <td>
//                               <input
//                                 type="tel"
//                                 className={`form-control form-control-sm ${formErrors.purchase_gst ? "border-danger" : ""
//                                   }`}
//                                 value={item.purchase_gst}
//                                 onChange={(e) =>
//                                   handleEditPurchaseItemField(
//                                     index,
//                                     "purchase_gst",
//                                     e.target.value
//                                   )
//                                 }
//                                 style={{ width: "50px" }}
//                               />
//                             </td>
//                             <td>
//                               <input
//                                 type="tel"
//                                 className={`form-control form-control-sm ${formErrors.Mrp ? "border-danger" : ""
//                                   }`}
//                                 value={item.Mrp}
//                                 onChange={(e) =>
//                                   handleEditPurchaseItemField(
//                                     index,
//                                     "Mrp",
//                                     e.target.value
//                                   )
//                                 }
//                                 style={{ width: "100px" }}
//                               />
//                             </td>
//                             <td>
//                               <div className="d-flex gap-2">
//                                 <button
//                                   onClick={() => handleEditItem(index)}
//                                   className="border-0 bg-transparent cursor-pointer text-muted"
//                                 >
//                                   <Edit2 size={16} />
//                                 </button>
//                                 <button
//                                   onClick={() => handleDeleteItem(index)}
//                                   className="border-0 bg-transparent cursor-pointer text-muted"
//                                 >
//                                   <Trash2 size={16} />
//                                 </button>
//                               </div>
//                             </td>
//                           </tr>
//                           <tr>
//                             <td colSpan="7">
//                               <div className="card p-2 bg-light border rounded mb-2">
//                                 <div className="row">
//                                   <div className="col-md-12">
//                                     <strong>Tyre Size:</strong>{" "}
//                                     {item.tyre_size || "N/A"} |{" "}
//                                     <strong>MRP:</strong> {item.Mrp || "N/A"}
//                                   </div>
//                                 </div>
//                               </div>
//                             </td>
//                           </tr>
//                         </React.Fragment>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="7" className="text-center">
//                           No purchase items added
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Purchase Details */}
//         <div className="col-lg-3">
//           <div className="card h-100" style={{ backgroundColor: "#fff0f5" }}>
//             <div className="p-3">
//               <div className="row g-2 mb-2">
//                 <div className="col-md-5">
//                   <label className="form-label small fw-medium" style={{ fontSize: "14px" }}>
//                     Purchase No <span className="text-danger"></span>
//                   </label>
//                 </div>
//                 <div className="col-md-7">
//                   <input
//                     type="text"
//                     className="form-control form-control-sm"
//                     placeholder="Enter Purchase No"
//                     name="purchaseId"
//                     value={purchaseData.purchaseId}
//                     onChange={handlePurchaseDataChange}
//                     style={{
//                       padding: "10px",
//                       border: "1px solid #d1d3e2",
//                       borderRadius: "4px",
//                       fontSize: "14px",
//                       background: "white",
//                     }}
//                     required
//                   />
//                 </div>
//               </div>
//               <div className="row g-2 mb-2">
//                 <div className="col-md-5">
//                   <label className="form-label small fw-medium" style={{ fontSize: "14px" }}>
//                     Date <span className="text-danger">*</span>
//                   </label>
//                 </div>
//                 <div className="col-md-7">
//                   <input
//                     type="date"
//                     className={`form-control form-control-sm ${formErrors.purchaseDate ? "border-danger" : ""}`}
//                     placeholder="Select Date"
//                     name="purchaseDate"
//                     value={purchaseData.purchaseDate}
//                     onChange={handlePurchaseDataChange}
//                     style={{
//                       padding: "10px",
//                       border: "1px solid #d1d3e2",
//                       borderRadius: "4px",
//                       fontSize: "14px",
//                       background: "white",
//                     }}
//                     required
//                   />
//                   {formErrors.purchaseDate && (
//                     <div className="text-danger small">{formErrors.purchaseDate}</div>
//                   )}
//                 </div>
//               </div>


//               <div className="row g-2 mb-2">
//                 <div className="col-md-5">
//                   <label className="form-label small fw-medium" style={{ fontSize: "14px" }}>
//                     Dealer Name
//                   </label>
//                 </div>
//                 <div className="col-md-7">
//                   <input
//                     type="text"
//                     className="form-control form-control-sm"
//                     placeholder="Dealer Name"
//                     name="dealerName"
//                     value={purchaseData.dealerName}
//                     readOnly
//                     style={{
//                       padding: "10px",
//                       border: "1px solid #d1d3e2",
//                       borderRadius: "4px",
//                       fontSize: "14px",
//                       background: "white",
//                     }}
//                   />
//                 </div>
//               </div>



//               <div className="row g-2 mb-2">
//                 <div className="col-md-5">
//                   <label className="form-label small fw-medium" style={{ fontSize: "14px" }}>
//                     Mobile No
//                   </label>
//                 </div>
//                 <div className="col-md-7">
//                   <input
//                     type="text"
//                     className="form-control form-control-sm"
//                     placeholder="Mobile No"
//                     name="mobile_no"
//                     value={purchaseData.mobile_no}
//                     readOnly
//                     style={{
//                       padding: "10px",
//                       border: "1px solid #d1d3e2",
//                       borderRadius: "4px",
//                       fontSize: "14px",
//                       background: "white",
//                     }}
//                   />
//                 </div>
//               </div>

//               <div className="row g-2 mb-2">
//                 <div className="col-md-5">
//                   <label className="form-label small fw-semibold text-muted" style={{ fontSize: "14px" }}>
//                     Sub Total
//                   </label>
//                 </div>
//                 <div className="col-md-7">
//                   <input
//                     className="form-control form-control-sm bg-light"
//                     value={purchaseData.subTotal}
//                     name="subTotal"
//                     disabled
//                     style={{ padding: "8px", fontSize: "14px" }}
//                   />
//                 </div>
//               </div>


//               <div className="row g-2 mb-2">
//                 <div className="col-md-5">
//                   <label className="form-label small fw-semibold text-muted" style={{ fontSize: "14px" }}>
//                     GST Amount
//                   </label>
//                 </div>
//                 <div className="col-md-7">
//                   <input
//                     className="form-control form-control-sm bg-light"
//                     value={purchaseData.gstAmount}
//                     name="gstAmount"
//                     disabled
//                     style={{ padding: "8px", fontSize: "14px" }}
//                   />
//                 </div>
//               </div>
//               <div className="row g-2 mb-2">
//                 <div className="col-md-5">
//                   <label className="form-label small fw-semibold text-muted" style={{ fontSize: "14px" }}>
//                     Net Total
//                   </label>
//                 </div>
//                 <div className="col-md-7">
//                   <input
//                     className="form-control form-control-sm bg-light"
//                     value={purchaseData.netTotal}
//                     name="netTotal"
//                     disabled
//                     style={{ padding: "8px", fontSize: "14px" }}
//                   />
//                 </div>
//               </div>
//               <div className="row g-2 mb-2">
//                 <div className="col-md-5">
//                   <label className="form-label small fw-semibold text-muted" style={{ fontSize: "14px" }}>
//                     Paid Amount
//                   </label>
//                 </div>
//                 <div className="col-md-7">
//                   <input
//                     className="form-control form-control-sm"
//                     name="paidAmount"
//                     value={purchaseData.paidAmount}
//                     readOnly
//                     placeholder="₹0.00"
//                     style={{ padding: "8px", fontSize: "14px" }}
//                   />
//                 </div>
//               </div>
//               <div className="row g-2 mb-2">
//                 <div className="col-md-5">
//                   <label className="form-label small fw-semibold text-muted" style={{ fontSize: "14px" }}>
//                     Balance
//                   </label>
//                 </div>
//                 <div className="col-md-7 d-flex">
//                   <input
//                     className="form-control form-control-sm bg-light"
//                     value={purchaseData.balance}
//                     disabled
//                     style={{ padding: "8px", fontSize: "14px" }}
//                   />

//                 </div>
//               </div>
//               <div className="d-flex flex-column flex-md-row gap-1 mt-3">
//                 <button
//                   className="btn btn-success btn-sm ms-2"
//                   type="button"
//                   onClick={() => setShowPaymentModal(true)}
//                 >
//                   Add payment
//                 </button>
//                 <button
//                   className="btn btn-success btn-sm btn-custom d-flex align-items-center shadow-sm"
//                   onClick={handleSubmit}
//                   disabled={isLoading}
//                 >
//                   Save
//                 </button>
//                 {/* <button
//           className="btn btn-primary btn-sm btn-custom d-flex align-items-center shadow-sm"
//           onClick={handlePrint}
//         >
//           Print
//         </button> */}
//                 <button
//                   className="btn btn-danger btn-sm btn-custom d-flex align-items-center shadow-sm"
//                   onClick={handleCancel}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div
//         className="card-body bg-opacity-10 p-md-3 mx-4 mt-1"
//         style={{ borderRadius: "10px" }}
//       >
//         <div className="d-flex justify-content-between p-2 p-md-3 mt-2 no-print"></div>
//       </div>

//       {/* Add Product Modal */}
//       <div
//         className={`modal fade ${showModal ? "show" : ""}`}
//         style={{
//           display: showModal ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//         tabIndex="-1"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div
//             className="modal-content rounded"
//             style={{ backgroundColor: "rgb(255, 240, 245)" }}
//           >
//             <div className="modal-header bg-pink-light border-bottom-0">
//               <h5 className="modal-title m-0 fw-semibold">Add Product</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 onClick={() => setShowModal(false)}
//                 disabled={isLoading}
//               ></button>
//             </div>
//             <div className="modal-body bg-light">
//               <div className="row g-3">
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium">
//                     HSN Code <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control form-control-sm"
//                     value={productData.HSN_code}
//                     readOnly
//                     placeholder="Auto-generated HSN Code"
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium">
//                     Category <span className="text-danger">*</span>
//                   </label>
//                   <select
//                     className="form-select form-select-sm"
//                     value={productData.Category}
//                     onChange={(e) =>
//                       setProductData({
//                         ...productData,
//                         Category: e.target.value,
//                         Subcategory: "",
//                       })
//                     }
//                     required
//                   >
//                     <option value="">Select Category</option>
//                     {categoryTableData.map((category) => (
//                       <option key={category.Category} value={category.Category}>
//                         {category.Category}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium">
//                     Subcategory <span className="text-danger">*</span>
//                   </label>
//                   <select
//                     className="form-select form-select-sm"
//                     value={productData.Subcategory}
//                     onChange={(e) =>
//                       setProductData({
//                         ...productData,
//                         Subcategory: e.target.value,
//                       })
//                     }
//                     disabled={!productData.Category}
//                     required
//                   >
//                     <option value="">Select Subcategory</option>
//                     {productData.Category &&
//                       categoryTableData
//                         .find((cat) => cat.Category === productData.Category)
//                         ?.SubCategories?.map((subcat) => (
//                           <option key={subcat} value={subcat}>
//                             {subcat}
//                           </option>
//                         ))}
//                   </select>
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium">
//                     Branch Name
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control form-control-sm"
//                     value={productData.branch_name}
//                     onChange={(e) =>
//                       setProductData({
//                         ...productData,
//                         branch_name: e.target.value,
//                       })
//                     }
//                     placeholder="Enter Branch Name"
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium">
//                     Brand Name
//                   </label>
//                   <select
//                     className="form-select form-select-sm"
//                     value={productData.brand_name}
//                     onChange={(e) =>
//                       setProductData({
//                         ...productData,
//                         brand_name: e.target.value,
//                       })
//                     }
//                   >
//                     <option value="">Select Brand Name</option>
//                     <option value="MRF">MRF</option>
//                     <option value="CEAT">CEAT</option>
//                     <option value="Apollo">Apollo</option>
//                     <option value="JK Tyre">JK Tyre</option>
//                     <option value="Bridgestone">Bridgestone</option>
//                   </select>
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium">
//                     Type
//                   </label>
//                   <select
//                     className="form-select form-select-sm"
//                     value={productData.type}
//                     onChange={(e) =>
//                       setProductData({ ...productData, type: e.target.value })
//                     }
//                   >
//                     <option value="">Select Type</option>
//                     <option value="Radial">Radial</option>
//                     <option value="Bias">Bias</option>
//                     <option value="Tubeless">Tubeless</option>
//                     <option value="Tube Type">Tube Type</option>
//                     <option value="Solid">Solid</option>
//                   </select>
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium">
//                     Tyre Size
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control form-control-sm"
//                     value={productData.tyre_size}
//                     onChange={(e) =>
//                       setProductData({
//                         ...productData,
//                         tyre_size: e.target.value,
//                       })
//                     }
//                     placeholder="Enter Tyre Size"
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium">
//                     Rate <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="number"
//                     className="form-control form-control-sm"
//                     value={productData.rate}
//                     onChange={(e) =>
//                       setProductData({ ...productData, rate: e.target.value })
//                     }
//                     placeholder="Enter Rate"
//                     required
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium">
//                     GST <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="number"
//                     className="form-control form-control-sm"
//                     value={productData.gst}
//                     onChange={(e) =>
//                       setProductData({ ...productData, gst: e.target.value })
//                     }
//                     placeholder="Enter GST"
//                     required
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium">
//                     MRP <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="number"
//                     className="form-control form-control-sm"
//                     value={productData.Mrp}
//                     onChange={(e) =>
//                       setProductData({ ...productData, Mrp: e.target.value })
//                     }
//                     placeholder="Enter MRP"
//                     required
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium">
//                     Product Status
//                   </label>
//                   <select
//                     className="form-select form-select-sm"
//                     value={productData.status}
//                     onChange={(e) =>
//                       setProductData({ ...productData, status: e.target.value })
//                     }
//                   >
//                     <option value="Active">Active</option>
//                     <option value="Inactive">Inactive</option>
//                   </select>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer border-top-0">
//               <button
//                 type="button"
//                 className="btn btn-sm btn-danger"
//                 onClick={() => setShowModal(false)}
//                 disabled={isLoading}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 className="btn btn-sm btn-success"
//                 onClick={handleProductSubmit}
//                 disabled={isLoading}
//               >
//                 {isLoading ? "Adding..." : "Confirm"}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Payment Modal */}
//       <div
//         className={`modal fade ${showPaymentModal ? "show" : ""}`}
//         style={{
//           display: showPaymentModal ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//       >
//         <div className="modal-dialog">
//           <div
//             className="modal-content"
//             style={{ backgroundColor: "rgb(255, 240, 245)" }}
//           >
//             <div className="modal-header bg-pink-light border-bottom-0">
//               <h5 className="modal-title m-0 fw-semibold">Add Payment</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 onClick={() => {
//                   setShowPaymentModal(false);
//                   resetPaymentForm();
//                 }}
//               ></button>
//             </div>
//             <div className="mx-4">
//               <div className="row">
//                 <div className="col-md-5">
//                   <label className="form-label fw-medium small">
//                     Balance:
//                     <input
//                       className="form-control form-control-sm mt-1 text-success"
//                       value={(
//                         Number(purchaseData.netTotal) -
//                         Number(purchaseData.paidAmount)
//                       ).toFixed(2)}
//                       disabled
//                     />
//                   </label>
//                 </div>
//                 <div className="col-md-5">
//                   <label className="form-label fw-medium small">
//                     Paid:
//                     <input
//                       className="form-control form-control-sm mt-1 text-success"
//                       value={purchaseData.paidAmount}
//                       disabled
//                     />
//                   </label>
//                 </div>
//               </div>
//             </div>
//             <div className="mx-3 mt-2">
//               <div className="row gap-2">
//                 <div className="col-md-5">
//                   <select
//                     className="form-select form-select-sm"
//                     name="pay_type"
//                     value={paymentForm.pay_type}
//                     onChange={handlePaymentChange}
//                   >
//                     <option value="">Select Pay Type</option>
//                     <option value="Cash">Cash</option>
//                     <option value="Gpay">Gpay</option>
//                     <option value="Phonepay">Phonepay</option>
//                     <option value="Paytm">Paytm</option>
//                     <option value="Credit">Credit</option>
//                     <option value="Debit">Debit</option>
//                   </select>
//                 </div>
//                 <div className="col-md-4">
//                   <input
//                     className="form-control form-control-sm"
//                     name="amount"
//                     type="number"
//                     value={paymentForm.amount}
//                     onChange={handlePaymentChange}
//                     placeholder="Enter Amount"
//                   />
//                 </div>
//                 <div className="col-md-2">
//                   <button
//                     className="btn btn-success btn-sm"
//                     onClick={handleAddPayment}
//                   >
//                     {paymentEditIndex !== null ? "Update" : "Add"}
//                   </button>
//                 </div>
//               </div>
//             </div>
//             <div className="card mx-3 mt-3 mb-3">
//               <div className="d-flex justify-content-center">
//                 <table className="table table-bordered text-center mx-3 mt-3">
//                   <thead className="small fw-light">
//                     <tr>
//                       <th>S.No</th>
//                       <th>Pay Type</th>
//                       <th>Amount</th>
//                       <th>Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {paymentHistory.map((payment, index) => (
//                       <tr key={payment.id}>
//                         <td>{index + 1}</td>
//                         <td>{payment.pay_type}</td>
//                         <td>{payment.amount}</td>
//                         <td>
//                           <div className="d-flex gap-2 justify-content-center">
//                             <button
//                               className="btn btn-sm btn-primary"
//                               onClick={() => handleEditPayment(index)}
//                             >
//                               <Edit2 size={16} />
//                             </button>
//                             <button
//                               className="btn btn-sm btn-danger"
//                               onClick={() => handleDeletePayment(index)}
//                             >
//                               <Trash2 size={16} />
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//             <div className="d-flex justify-content-end mx-4 mb-3">
//               <button
//                 className="btn btn-success btn-sm"
//                 onClick={() => {
//                   setShowPaymentModal(false);
//                   resetPaymentForm();
//                 }}
//               >
//                 Submit
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddPurchases;



import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Plus, Trash2, Edit2, ChevronDown, ChevronUp } from "lucide-react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ApiUrl from "../Environment/ApiUrl";

const AddPurchases = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [categoryTableData, setCategoryTableData] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState({});
  const [quantities, setQuantities] = useState({});

  // State for purchase data
  const [purchaseData, setPurchaseData] = useState({
    purchaseId: "",
    purchaseDate: new Date().toISOString().split("T")[0],
    mobile_no: "",
    dealerName: "",
    subTotal: 0,
    gstAmount: 0,
    netTotal: 0,
    paidAmount: 0,
    balance: 0,
  });

  // State for purchase items
  const [purchaseItems, setPurchaseItems] = useState([]);
  const [showAddRow, setShowAddRow] = useState(true);
  const [editIndex, setEditIndex] = useState(null);
  const [purchaseItemForm, setPurchaseItemForm] = useState({
    HSN_code: "",
    branch_name: "Default Branch",
    brand_name: "",
    type: "",
    tyre_size: "",
    Quantity: "",
    purchase_rate: "",
    Gst: "",
    Category: "",
    Subcategory: "",
    status: "In Stock",
    purchase_quantity: "",
    purchase_gst: "",
    Mrp: "",
  });

  // State for form validation errors
  const [formErrors, setFormErrors] = useState({
    brand_name: "",
    Quantity: "",
    purchase_rate: "",
    Gst: "",
    purchaseDate: "",
    purchase_quantity: "",
    purchase_gst: "",
    Mrp: "",
    dealerName: "",
    mobile_no: "",
  });

  // State for payment history
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentForm, setPaymentForm] = useState({
    date: new Date().toISOString().split("T")[0],
    pay_type: "",
    amount: "",
  });
  const [paymentEditIndex, setPaymentEditIndex] = useState(null);

  // State for product modal
  const [showModal, setShowModal] = useState(false);
  const [productData, setProductData] = useState({
    HSN_code: "",
    Category: "",
    Subcategory: "",
    branch_name: "Default Branch",
    brand_name: "",
    type: "",
    tyre_size: "",
    rate: "",
    gst: "",
    status: "Active",
    Mrp: "",
  });

  // Validate purchase item form
  const validatePurchaseItemForm = () => {
    const errors = {};
    if (!purchaseItemForm.brand_name) errors.brand_name = "Brand is required";
    if (!purchaseItemForm.Quantity) errors.Quantity = "Quantity is required";
    else if (
      isNaN(purchaseItemForm.Quantity) ||
      Number(purchaseItemForm.Quantity) <= 0
    )
      errors.Quantity = "Quantity must be a positive number";
    if (!purchaseItemForm.purchase_rate)
      errors.purchase_rate = "Purchase Rate is required";
    else if (
      isNaN(purchaseItemForm.purchase_rate) ||
      Number(purchaseItemForm.purchase_rate) <= 0
    )
      errors.purchase_rate = "Purchase Rate must be a positive number";
    if (!purchaseItemForm.Gst) errors.Gst = "GST is required";
    else if (isNaN(purchaseItemForm.Gst) || Number(purchaseItemForm.Gst) < 0)
      errors.Gst = "GST must be a non-negative number";
    if (!purchaseItemForm.purchase_quantity)
      errors.purchase_quantity = "Purchase Quantity is required";
    else if (
      isNaN(purchaseItemForm.purchase_quantity) ||
      Number(purchaseItemForm.purchase_quantity) <= 0
    )
      errors.purchase_quantity = "Purchase Quantity must be a positive number";
    if (!purchaseItemForm.purchase_gst)
      errors.purchase_gst = "Purchase GST is required";
    else if (
      isNaN(purchaseItemForm.purchase_gst) ||
      Number(purchaseItemForm.purchase_gst) < 0
    )
      errors.purchase_gst = "Purchase GST must be a non-negative number";
    if (!purchaseItemForm.Mrp) errors.Mrp = "MRP is required";
    else if (isNaN(purchaseItemForm.Mrp) || Number(purchaseItemForm.Mrp) <= 0)
      errors.Mrp = "MRP must be a positive number";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Calculate totals
  const calculateTotals = useCallback((items, payments) => {
    const subTotal = items.reduce((sum, item) => {
      const quantity = Number(item.purchase_quantity) || 0;
      const rate = Number(item.purchase_rate) || 0;
      return sum + quantity * rate;
    }, 0);

    const gstAmount = items.reduce((sum, item) => {
      const quantity = Number(item.purchase_quantity) || 0;
      const rate = Number(item.purchase_rate) || 0;
      const gst = Number(item.purchase_gst) || 0;
      return sum + (quantity * rate * gst) / 100;
    }, 0);

    const netTotal = subTotal + gstAmount;
    const paidAmount = payments.reduce(
      (sum, payment) => sum + (Number(payment.amount) || 0),
      0
    );
    const balance = netTotal - paidAmount;
    const paymentStatus =
      paidAmount >= netTotal ? "PAID" : paidAmount > 0 ? "PARTIAL" : "UNPAID";

    setPurchaseData((prev) => ({
      ...prev,
      subTotal: subTotal.toFixed(2),
      gstAmount: gstAmount.toFixed(2),
      netTotal: netTotal.toFixed(2),
      paidAmount: paidAmount.toFixed(2),
      balance: balance.toFixed(2),
      paymentStatus,
    }));
  }, []);

  // Fetch initial data
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const productResponse = await axios.get(`${ApiUrl}/product_data.php`);
        let fetchedData = Array.isArray(productResponse.data.data)
          ? productResponse.data.data
          : [];
        const requestedProduct = {
          id: `custom_${Date.now()}`,
          HSN_code: "HSN001",
          Category: "LT",
          Subcategory: "Pick up Radils",
          branch_name: "Default Branch",
          brand_name: "MRF",
          type: "Tubeless",
          tyre_size: "100/90-17",
          status: "Inactive",
          rate: "1000",
          gst: "18",
          Mrp: "1200",
        };
        const exists = fetchedData.some(
          (item) =>
            item.brand_name === requestedProduct.brand_name &&
            item.tyre_size === requestedProduct.tyre_size
        );
        if (!exists) {
          fetchedData = [...fetchedData, requestedProduct];
        }
        setProducts(fetchedData);

        const categoriesMap = {};
        fetchedData.forEach((item) => {
          if (!item.Category) return;
          if (!categoriesMap[item.Category]) {
            categoriesMap[item.Category] = new Set();
          }
          if (item.Subcategory && typeof item.Subcategory === "string") {
            item.Subcategory.split(",")
              .map((subCat) => subCat.trim())
              .filter((subCat) => subCat.length > 0)
              .forEach((subCat) => categoriesMap[item.Category].add(subCat));
          }
        });
        if (!categoriesMap["LT"]) {
          categoriesMap["LT"] = new Set(["Pick up Radils"]);
        } else {
          categoriesMap["LT"].add("Pick up Radils");
        }
        const transformedData = Object.keys(categoriesMap).map((category) => ({
          Category: category,
          SubCategories: Array.from(categoriesMap[category]),
        }));
        setCategoryTableData(transformedData);

        const initialQuantities = {};
        fetchedData.forEach((item) => {
          initialQuantities[item.id] = 0;
        });
        setQuantities(initialQuantities);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Error fetching data: " + error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const fetchNextProductId = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${ApiUrl}/product_data.php/generate-product-code`
      );
      if (!response.data || !response.data.HSN_code) {
        throw new Error("Invalid response structure: HSN_code not found");
      }
      setProductData((prev) => ({
        ...prev,
        HSN_code: response.data.HSN_code,
      }));
      setError(null);
    } catch (error) {
      console.error(
        "Error fetching product ID:",
        error.message,
        error.response?.data
      );
      setError(
        error.response?.data?.message ||
          "Failed to fetch product ID. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const toggleCategory = (category) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  const handleQuantityChange = useCallback(
    (item, action) => {
      setQuantities((prev) => {
        const newQuantities = { ...prev };
        const itemKey = item.id;
        const currentQuantity = newQuantities[itemKey] || 0;
        const newQuantity =
          action === "increase"
            ? currentQuantity + 1
            : currentQuantity > 0
              ? currentQuantity - 1
              : 0;

        newQuantities[itemKey] = newQuantity;

        const newItem = {
          id: item.id,
          purchaseId: purchaseData.purchaseId,
          purchaseRefId: Date.now().toString(),
          HSN_code: item.HSN_code,
          branch_name: item.branch_name || "Default Branch",
          brand_name: item.brand_name,
          type: item.type,
          tyre_size: item.tyre_size,
          status: item.status,
          Category: item.Category,
          Subcategory: item.Subcategory,
          Quantity: newQuantity,
          purchase_rate: Number(item.rate) || 0,
          Gst: Number(item.gst) || 0,
          purchase_quantity: newQuantity,
          purchase_gst: Number(item.gst) || 0,
          Mrp: Number(item.Mrp) || 0,
        };

        setPurchaseItems((prevItems) => {
          const existingItemIndex = prevItems.findIndex(
            (pi) => pi.id === item.id
          );
          let updatedItems;
          if (newQuantity === 0) {
            updatedItems = prevItems.filter((_, i) => i !== existingItemIndex);
          } else if (existingItemIndex >= 0) {
            updatedItems = [...prevItems];
            updatedItems[existingItemIndex] = newItem;
          } else {
            updatedItems = [...prevItems, newItem];
          }
          calculateTotals(updatedItems, paymentHistory);
          return updatedItems;
        });

        return newQuantities;
      });
    },
    [calculateTotals, purchaseData.purchaseId, paymentHistory]
  );

  const handlePurchaseDataChange = (e) => {
    const { name, value } = e.target;
    setPurchaseData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({
      ...prev,
      [name]: !value
        ? `${
            name === "dealerName"
              ? "Dealer Name"
              : name === "mobile_no"
                ? "Mobile Number"
                : name
          } is required`
        : name === "mobile_no" && !/^[0-9]{10}$/.test(value)
          ? "Mobile number must be a valid 10-digit number"
          : "",
    }));
  };

  const handlePurchaseItemChange = (e) => {
    const { name, value } = e.target;
    setPurchaseItemForm((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({
      ...prev,
      [name]: !value
        ? `${name === "brand_name" ? "Brand" : name} is required`
        : isNaN(value) ||
          Number(value) <= (name === "Gst" || name === "purchase_gst" ? -1 : 0)
        ? `${name} must be a ${
            name === "Gst" || name === "purchase_gst" ? "non-negative" : "positive"
          } number`
        : "",
    }));
    if (name === "brand_name") {
      const selectedProduct = products.find(
        (product) => product.brand_name === value
      );
      setPurchaseItemForm((prev) => ({
        ...prev,
        branch_name: "Default Branch",
        brand_name: value,
        tyre_size: selectedProduct ? selectedProduct.tyre_size : "",
        type: selectedProduct ? selectedProduct.type : "",
        purchase_rate: selectedProduct ? selectedProduct.rate : "",
        Gst: selectedProduct ? selectedProduct.gst : "",
        HSN_code: selectedProduct ? selectedProduct.HSN_code : "",
        Category: selectedProduct ? selectedProduct.Category : "",
        Subcategory: selectedProduct ? selectedProduct.Subcategory : "",
        purchase_quantity: "",
        purchase_gst: selectedProduct ? selectedProduct.gst : "",
        Mrp: selectedProduct ? selectedProduct.Mrp : "",
      }));
      setFormErrors((prev) => ({
        ...prev,
        brand_name: !value ? "Brand is required" : "",
      }));
    }
  };

  const handleAddPurchaseItem = () => {
    if (!validatePurchaseItemForm()) {
      setShowAddRow(true);
      setError("Please fill all item fields correctly");
      return;
    }

    const newItem = {
      ...purchaseItemForm,
      id:
        editIndex !== null
          ? purchaseItems[editIndex].id
          : Date.now().toString(),
      purchaseId: purchaseData.purchaseId,
      purchaseRefId: Date.now().toString(),
      Quantity: Number(purchaseItemForm.Quantity),
      purchase_rate: Number(purchaseItemForm.purchase_rate) || 0,
      Gst: Number(purchaseItemForm.Gst) || 0,
      purchase_quantity: Number(purchaseItemForm.purchase_quantity) || 0,
      purchase_gst: Number(purchaseItemForm.purchase_gst) || 0,
      Mrp: Number(purchaseItemForm.Mrp) || 0,
    };

    let updatedItems;
    if (editIndex !== null) {
      updatedItems = [...purchaseItems];
      updatedItems[editIndex] = newItem;
      setEditIndex(null);
    } else {
      updatedItems = [...purchaseItems, newItem];
    }

    setPurchaseItems(updatedItems);
    calculateTotals(updatedItems, paymentHistory);
    resetPurchaseItemForm();
    setShowAddRow(false);
  };

  const resetPurchaseItemForm = () => {
    setPurchaseItemForm({
      HSN_code: "",
      branch_name: "Default Branch",
      brand_name: "",
      type: "",
      tyre_size: "",
      Quantity: "",
      purchase_rate: "",
      Gst: "",
      Category: "",
      Subcategory: "",
      status: "In Stock",
      purchase_quantity: "",
      purchase_gst: "",
      Mrp: "",
    });
    setFormErrors({
      brand_name: "",
      Quantity: "",
      purchase_rate: "",
      Gst: "",
      purchaseDate: "",
      purchase_quantity: "",
      purchase_gst: "",
      Mrp: "",
      dealerName: "",
      mobile_no: "",
    });
    setShowAddRow(true);
  };

  const handleEditPurchaseItemField = (index, field, value) => {
    const updatedItems = [...purchaseItems];
    updatedItems[index] = { ...updatedItems[index], [field]: value };

    // Validate the edited field
    const errors = {};
    if (field === "Quantity") {
      if (!value) errors.Quantity = "Quantity is required";
      else if (isNaN(value) || Number(value) <= 0)
        errors.Quantity = "Quantity must be a positive number";
    }
    if (field === "purchase_rate") {
      if (!value) errors.purchase_rate = "Purchase Rate is required";
      else if (isNaN(value) || Number(value) <= 0)
        errors.purchase_rate = "Purchase Rate must be a positive number";
    }
    if (field === "Gst") {
      if (!value) errors.Gst = "GST is required";
      else if (isNaN(value) || Number(value) < 0)
        errors.Gst = "GST must be a non-negative number";
    }
    if (field === "purchase_quantity") {
      if (!value) errors.purchase_quantity = "Purchase Quantity is required";
      else if (isNaN(value) || Number(value) <= 0)
        errors.purchase_quantity = "Purchase Quantity must be a positive number";
    }
    if (field === "purchase_gst") {
      if (!value) errors.purchase_gst = "Purchase GST is required";
      else if (isNaN(value) || Number(value) < 0)
        errors.purchase_gst = "Purchase GST must be a non-negative number";
    }
    if (field === "Mrp") {
      if (!value) errors.Mrp = "MRP is required";
      else if (isNaN(value) || Number(value) <= 0)
        errors.Mrp = "MRP must be a positive number";
    }
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      setPurchaseItems(updatedItems);
      calculateTotals(updatedItems, paymentHistory);
    }
  };

  const handleEditItem = (index) => {
    setPurchaseItemForm(purchaseItems[index]);
    setEditIndex(index);
    setShowAddRow(true);
    setFormErrors({
      brand_name: "",
      Quantity: "",
      purchase_rate: "",
      Gst: "",
      purchaseDate: "",
      purchase_quantity: "",
      purchase_gst: "",
      Mrp: "",
      dealerName: "",
      mobile_no: "",
    });
  };

  const handleDeleteItem = (index) => {
    const updatedItems = purchaseItems.filter((_, i) => i !== index);
    setPurchaseItems(updatedItems);
    calculateTotals(updatedItems, paymentHistory);
    setQuantities((prev) => ({
      ...prev,
      [purchaseItems[index].id]: 0,
    }));
  };

  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    setPaymentForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddPayment = () => {
    if (!paymentForm.pay_type || !paymentForm.amount) {
      setError("Please fill all payment fields");
      return;
    }

    if (isNaN(paymentForm.amount) || Number(paymentForm.amount) <= 0) {
      setError("Payment amount must be a valid positive number");
      return;
    }

    const newPayment = {
      ...paymentForm,
      id:
        paymentEditIndex !== null
          ? paymentHistory[paymentEditIndex].id
          : Date.now().toString(),
      amount: Number(paymentForm.amount),
    };

    let updatedHistory;
    if (paymentEditIndex !== null) {
      updatedHistory = [...paymentHistory];
      updatedHistory[paymentEditIndex] = newPayment;
      setPaymentEditIndex(null);
    } else {
      updatedHistory = [...paymentHistory, newPayment];
    }

    setPaymentHistory(updatedHistory);
    calculateTotals(purchaseItems, updatedHistory);
    resetPaymentForm();

    toast.success("Payment added successfully!");
  };

  const resetPaymentForm = () => {
    setPaymentForm({
      date: new Date().toISOString().split("T")[0],
      pay_type: "",
      amount: "",
    });
  };

  const handleEditPayment = (index) => {
    setPaymentForm(paymentHistory[index]);
    setPaymentEditIndex(index);
  };

  const handleDeletePayment = (index) => {
    const updatedPayments = paymentHistory.filter((_, i) => i !== index);
    setPaymentHistory(updatedPayments);
    calculateTotals(purchaseItems, updatedPayments);
    toast.success("Payment deleted successfully!");
  };

  const handleCancel = () => {
    navigate("/purchases");
  };

  const handleSubmit = async () => {
    // Validate all required fields
    const errors = {};
    if (!purchaseData.purchaseId) errors.purchaseId = "Purchase ID is required";
    if (!purchaseData.purchaseDate)
      errors.purchaseDate = "Purchase date is required";
    if (!purchaseData.dealerName) errors.dealerName = "Dealer name is required";
    if (!purchaseData.mobile_no) errors.mobile_no = "Mobile number is required";
    if (!purchaseData.subTotal) errors.subTotal = "Sub total is required";
    if (!purchaseData.gstAmount) errors.gstAmount = "GST amount is required";
    if (!purchaseData.netTotal) errors.netTotal = "Net total is required";
    if (!purchaseData.paidAmount) errors.paidAmount = "Paid amount is required";
    if (!purchaseData.paymentStatus)
      errors.paymentStatus = "Payment status is required";
    if (purchaseItems.length === 0)
      errors.purchaseItems = "At least one purchase item is required";

    if (Object.keys(errors).length > 0) {
      setError(Object.values(errors).join(", "));
      return;
    }

    // Validate mobile number format (basic validation for 10 digits)
    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(purchaseData.mobile_no)) {
      setError("Mobile number must be a valid 10-digit number");
      setFormErrors((prev) => ({
        ...prev,
        mobile_no: "Mobile number must be a valid 10-digit number",
      }));
      return;
    }

    // Ensure purchaseDate is in the correct format
    let formattedPurchaseDate;
    try {
      formattedPurchaseDate = new Date(purchaseData.purchaseDate)
        .toISOString()
        .split("T")[0];
      if (!formattedPurchaseDate || formattedPurchaseDate === "Invalid Date") {
        setError("Invalid purchase date format");
        setFormErrors((prev) => ({
          ...prev,
          purchaseDate: "Invalid purchase date format",
        }));
        return;
      }
    } catch (error) {
      setError("Invalid purchase date format");
      setFormErrors((prev) => ({
        ...prev,
        purchaseDate: "Invalid purchase date format",
      }));
      return;
    }

    // Validate purchase items
    for (let i = 0; i < purchaseItems.length; i++) {
      const item = purchaseItems[i];
      const itemErrors = {};

      if (!item.HSN_code)
        itemErrors.HSN_code = `Item ${i + 1}: HSN code is required`;
      if (!item.brand_name)
        itemErrors.brand_name = `Item ${i + 1}: Brand name is required`;
      if (!item.type) itemErrors.type = `Item ${i + 1}: Type is required`;
      if (!item.tyre_size)
        itemErrors.tyre_size = `Item ${i + 1}: Tyre size is required`;
      if (!item.status) itemErrors.status = `Item ${i + 1}: Status is required`;
      if (!item.Category)
        itemErrors.Category = `Item ${i + 1}: Category is required`;
      if (!item.Subcategory)
        itemErrors.Subcategory = `Item ${i + 1}: Subcategory is required`;
      if (!item.purchase_quantity)
        itemErrors.purchase_quantity = `Item ${i + 1}: Purchase Quantity is required`;
      if (!item.purchase_gst)
        itemErrors.purchase_gst = `Item ${i + 1}: Purchase GST is required`;
      if (!item.purchase_rate)
        itemErrors.purchase_rate = `Item ${i + 1}: Purchase Rate is required`;
      if (!item.Mrp) itemErrors.Mrp = `Item ${i + 1}: MRP is required`;

      if (Object.keys(itemErrors).length > 0) {
        setError(Object.values(itemErrors).join(", "));
        return;
      }
    }

    // Create payload for purchase_data.php
    const purchasePayload = {
      purchaseId: purchaseData.purchaseId,
      purchaseDate: formattedPurchaseDate,
      mobile_no: purchaseData.mobile_no,
      dealerName: purchaseData.dealerName,
      subTotal: parseFloat(purchaseData.subTotal) || 0,
      gstAmount: parseFloat(purchaseData.gstAmount) || 0,
      netTotal: parseFloat(purchaseData.netTotal) || 0,
      paidAmount: parseFloat(purchaseData.paidAmount) || 0,
      balance: purchaseData.balance,
      purchaseItems: purchaseItems.map((item) => ({
        HSN_code: item.HSN_code,
        brand_name: item.brand_name,
        type: item.type,
        tyre_size: item.tyre_size,
        status: item.status,
        Category: item.Category,
        Subcategory: item.Subcategory,
        Quantity: item.Quantity || 0,
        purchase_rate: item.purchase_rate || 0,
        Gst: item.Gst || 0,
        purchase_quantity: item.purchase_quantity || 0,
        purchase_gst: item.purchase_gst || 0,
        Mrp: item.Mrp || 0,
      })),
      purchasePaymentHistory: paymentHistory.map((payment) => ({
        date: payment.date,
        pay_type: payment.pay_type,
        amount: parseFloat(payment.amount) || 0,
      })),
    };

    try {
      setIsLoading(true);

      // Post to purchase_data.php
      const purchaseResponse = await axios.post(
        `${ApiUrl}/purchase_data.php`,
        purchasePayload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Post to stockdata.php for each purchase item
      for (const item of purchaseItems) {
        const stockPayload = {
          hsn_code: item.HSN_code,
          type: item.type,
          tyre_size: item.tyre_size,
          category: item.Category,
          subcategory: item.Subcategory,
          purchase_rate: parseFloat(item.purchase_rate) || 0,
          avg_purchase_rate: parseFloat(item.purchase_rate) || 0,
          mrp: item.Mrp || "0",
          available_quantity: item.purchase_quantity || 0,
          total_purchase_quantity: item.purchase_quantity || 0,
          sold_quantity: 0,
          total_purchases: 1,
        };

        const stockResponse = await axios.post(
          `http://localhost/manuel_tyre/stockdata.php`,
          stockPayload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (stockResponse.data.status !== true) {
          throw new Error(
            `Failed to update stock for item ${item.HSN_code}: ${stockResponse.data.message}`
          );
        }
      }

      toast.success("Purchase and stock data added successfully!");
      navigate("/purchases");
    } catch (error) {
      console.error("Error saving data:", error);
      if (error.response && error.response.data) {
        setError(
          "Error saving data: " +
            (error.response.data.message || error.message)
        );
      } else {
        setError("Error saving data: " + error.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleProductSubmit = async (e) => {
    e.preventDefault();
    if (
      !productData.Category ||
      !productData.Subcategory ||
      !productData.rate ||
      !productData.gst ||
      !productData.Mrp
    ) {
      setError("Please fill all required product fields");
      return;
    }

    if (
      isNaN(productData.rate) ||
      isNaN(productData.gst) ||
      Number(productData.rate) <= 0 ||
      Number(productData.gst) < 0 ||
      isNaN(productData.Mrp) ||
      Number(productData.Mrp) <= 0
    ) {
      setError("Rate, GST, and MRP must be valid positive numbers");
      return;
    }

    try {
      setIsLoading(true);
      const formData = {
        HSN_code: productData.HSN_code,
        Category: productData.Category,
        Subcategory: productData.Subcategory,
        branch_name: productData.branch_name,
        brand_name: productData.brand_name,
        type: productData.type,
        tyre_size: productData.tyre_size,
        rate: Number(productData.rate),
        gst: Number(productData.gst),
        status: productData.status,
        Mrp: Number(productData.Mrp),
      };
      await axios.post(`${ApiUrl}/product_data.php`, formData);
      const newProduct = { ...formData, id: Date.now().toString() };
      setProducts((prev) => [...prev, newProduct]);
      const updatedCategories = [...categoryTableData];
      const categoryIndex = updatedCategories.findIndex(
        (cat) => cat.Category === formData.Category
      );
      if (categoryIndex >= 0) {
        if (
          !updatedCategories[categoryIndex].SubCategories.includes(
            formData.Subcategory
          )
        ) {
          updatedCategories[categoryIndex].SubCategories.push(
            formData.Subcategory
          );
        }
      } else {
        updatedCategories.push({
          Category: formData.Category,
          SubCategories: [formData.Subcategory],
        });
      }
      setCategoryTableData(updatedCategories);
      setQuantities((prev) => ({ ...prev, [newProduct.id]: 0 }));
      fetchNextProductId();
      setShowModal(false);
      setPurchaseItemForm((prev) => ({
        ...prev,
        HSN_code: formData.HSN_code,
        branch_name: formData.branch_name,
        brand_name: formData.brand_name,
        type: formData.type,
        tyre_size: formData.tyre_size,
        purchase_rate: formData.rate,
        Gst: formData.gst,
        Category: formData.Category,
        Subcategory: formData.Subcategory,
        purchase_quantity: "",
        purchase_gst: formData.gst,
        Mrp: formData.Mrp,
      }));
      setError(null);
    } catch (error) {
      console.error("Error adding product:", error);
      setError("Error adding product: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const [searchQuery, setSearchQuery] = useState("");

  // Filter products and categories based on search query
  const filteredData = useMemo(() => {
    if (!searchQuery.trim()) {
      return categoryTableData;
    }

    const query = searchQuery.toLowerCase().trim();
    const filtered = [];

    categoryTableData.forEach((category) => {
      const categoryMatches = category.Category.toLowerCase().includes(query);

      const matchingProducts = products.filter((item) => {
        if (item.Category !== category.Category) return false;

        return (
          item.brand_name?.toLowerCase().includes(query) ||
          item.type?.toLowerCase().includes(query) ||
          item.tyre_size?.toLowerCase().includes(query) ||
          item.Subcategory?.toLowerCase().includes(query) ||
          item.Category?.toLowerCase().includes(query)
        );
      });

      if (categoryMatches || matchingProducts.length > 0) {
        const matchingSubCategories = category.SubCategories.filter(
          (subCat) => {
            const subCatMatches = subCat.toLowerCase().includes(query);
            const hasMatchingProducts = matchingProducts.some((product) =>
              product.Subcategory?.toLowerCase().includes(subCat.toLowerCase())
            );
            return subCatMatches || hasMatchingProducts || categoryMatches;
          }
        );

        if (matchingSubCategories.length > 0) {
          filtered.push({
            ...category,
            SubCategories: matchingSubCategories,
          });
        }
      }
    });

    return filtered;
  }, [categoryTableData, products, searchQuery]);

  // Filter products for display based on search
  const getFilteredProducts = (categoryName) => {
    if (!searchQuery.trim()) {
      return products.filter((item) => item.Category === categoryName);
    }

    const query = searchQuery.toLowerCase().trim();
    return products.filter((item) => {
      if (item.Category !== categoryName) return false;

      return (
        item.brand_name?.toLowerCase().includes(query) ||
        item.type?.toLowerCase().includes(query) ||
        item.tyre_size?.toLowerCase().includes(query) ||
        item.Subcategory?.toLowerCase().includes(query) ||
        item.Category?.toLowerCase().includes(query)
      );
    });
  };

  // Auto-expand categories when searching
  useEffect(() => {
    if (searchQuery.trim()) {
      const newExpandedCategories = {};
      filteredData.forEach((category) => {
        newExpandedCategories[category.Category] = true;
      });
      setExpandedCategories(newExpandedCategories);
    }
  }, [searchQuery, filteredData]);

  // Clear search function
  const clearSearch = () => {
    setSearchQuery("");
  };

  return (
    <div className="bg-white font-sans overflow-x-hidden overflow-y-hidden">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />

      {error && (
        <div className="alert alert-danger mx-4" role="alert">
          {error}
        </div>
      )}
      {isLoading && <div className="text-center">Loading...</div>}
      <h2 className="m-0 fs-5 fw-semibold text-dark mx-4 mb-3">Add Purchase</h2>
      <div className="row g-3">
        {/* Product List */}
        <div className="col-lg-3">
          <div className="card p-3 h-100">
            <div className="mb-4 d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Product List</h5>
              <button
                className="btn btn-primary"
                onClick={() => {
                  setShowModal(true);
                  fetchNextProductId();
                }}
              >
                <Plus size={16} />
              </button>
            </div>

            <div className="mb-3">
              <label htmlFor="searchInput" className="form-label">
                Search Products
              </label>
              <div className="input-group">
                <input
                  type="text"
                  id="searchInput"
                  className="form-control"
                  placeholder="Search by category, brand, type, size..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                {searchQuery && (
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={clearSearch}
                    title="Clear search"
                  >
                    ×
                  </button>
                )}
              </div>
              {searchQuery && (
                <small className="text-muted">
                  Showing results for "{searchQuery}" ({filteredData.length}{" "}
                  categories found)
                </small>
              )}
            </div>

            <div className="table-responsive">
              <table
                className="table table-bordered table-sm"
                style={{ fontSize: "13px" }}
              >
                <thead>
                  <tr>
                    <th></th>
                    <th>Products</th>
                    <th>Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((category) => (
                    <React.Fragment key={category.Category}>
                      <tr>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => toggleCategory(category.Category)}
                          >
                            {expandedCategories[category.Category] ? (
                              <ChevronUp size={16} />
                            ) : (
                              <ChevronDown size={16} />
                            )}
                          </button>
                        </td>
                        <td colSpan="4" className="fw-bold">
                          {category.Category}
                        </td>
                      </tr>
                      {expandedCategories[category.Category] &&
                        getFilteredProducts(category.Category).map(
                          (item, index) => (
                            <tr key={item.id}>
                              <td></td>
                              <td>
                                {item.brand_name} - {item.type || "N/A"} -{" "}
                                {item.tyre_size || "N/A"}
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <button
                                    className="btn btn-sm btn-outline-secondary me-2"
                                    onClick={() =>
                                      handleQuantityChange(item, "decrease")
                                    }
                                    disabled={quantities[item.id] === 0}
                                  >
                                    -
                                  </button>
                                  <span>{quantities[item.id]}</span>
                                  <button
                                    className="btn btn-sm btn-outline-secondary ms-2"
                                    onClick={() =>
                                      handleQuantityChange(item, "increase")
                                    }
                                  >
                                    +
                                  </button>
                                </div>
                              </td>
                            </tr>
                          )
                        )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Purchase Items Table */}
        <div className="col-lg-6">
          <div className="card border h-100">
            <div className="card-body p-0">
              {/* <h5 className="p-2">Purchase Items List</h5> */}
              <div className="table-responsive">
                <table className="table table-hover mb-0 text-center">
                  <thead>
                    <tr style={{ backgroundColor: "#d3d3d3" }}>
                      <th className="p-3 text-start text-white fw-semibold small border-bottom  bg-danger">
                        S.No
                      </th>
                      <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        Products
                      </th>
                      <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        Pur Rate
                      </th>
                      <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        Qty
                      </th>
                      <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        GST (%)
                      </th>
                      <th className="p-3 text-start  text-white fw-semibold small border-bottom bg-danger">
                        MRP
                      </th>
                      <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {purchaseItems.length > 0 ? (
                      purchaseItems.map((item, index) => (
                        <React.Fragment key={item.id}>
                          <tr style={{ fontSize: "15px", fontWeight: "400" }}>
                            <td>{index + 1}</td>
                            <td>{item.brand_name}</td>
                            <td>
                              <input
                                type="tel"
                                className={`form-control form-control-sm ${
                                  formErrors.purchase_rate ? "border-danger" : ""
                                }`}
                                value={item.purchase_rate}
                                onChange={(e) =>
                                  handleEditPurchaseItemField(
                                    index,
                                    "purchase_rate",
                                    e.target.value
                                  )
                                }
                                style={{ width: "100px" }}
                              />
                            </td>
                            <td>
                              <input
                                type="tel"
                                className={`form-control form-control-sm ${
                                  formErrors.purchase_quantity
                                    ? "border-danger"
                                    : ""
                                }`}
                                value={item.purchase_quantity}
                                onChange={(e) =>
                                  handleEditPurchaseItemField(
                                    index,
                                    "purchase_quantity",
                                    e.target.value
                                  )
                                }
                                style={{ width: "50px" }}
                              />
                            </td>
                            <td>
                              <input
                                type="tel"
                                className={`form-control form-control-sm ${
                                  formErrors.purchase_gst ? "border-danger" : ""
                                }`}
                                value={item.purchase_gst}
                                onChange={(e) =>
                                  handleEditPurchaseItemField(
                                    index,
                                    "purchase_gst",
                                    e.target.value
                                  )
                                }
                                style={{ width: "50px" }}
                              />
                            </td>
                            <td>
                              <input
                                type="tel"
                                className={`form-control form-control-sm ${
                                  formErrors.Mrp ? "border-danger" : ""
                                }`}
                                value={item.Mrp}
                                onChange={(e) =>
                                  handleEditPurchaseItemField(
                                    index,
                                    "Mrp",
                                    e.target.value
                                  )
                                }
                                style={{ width: "100px" }}
                              />
                            </td>
                            <td>
                              <div className="d-flex gap-2">
                                {/* <button
                                  onClick={() => handleEditItem(index)}
                                  className="border-0 bg-transparent cursor-pointer text-muted"
                                >
                                  <Edit2 size={16} />
                                </button> */}
                                <button
                                  onClick={() => handleDeleteItem(index)}
                                  className="border-0 bg-transparent cursor-pointer text-muted"
                                >
                                  <Trash2 size={16} />
                                </button>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="7">
                              <div className="card p-2 bg-light border rounded mb-2">
                                <div className="row">
                                  <div className="col-md-12">
                                    <strong>Tyre Size:</strong>{" "}
                                    {item.tyre_size || "N/A"} |{" "}
                                    <strong>MRP:</strong> {item.Mrp || "N/A"}
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No purchase items added
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Purchase Details */}
        <div className="col-lg-3">
          <div className="card h-100" style={{ backgroundColor: "#fff0f5" }}>
            <div className="p-3">
              <div className="row g-2 mb-2">
                <div className="col-md-5">
                  <label
                    className="form-label small fw-medium"
                    style={{ fontSize: "14px" }}
                  >
                    Purchase No <span className="text-danger">*</span>
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Enter Purchase No"
                    name="purchaseId"
                    value={purchaseData.purchaseId}
                    onChange={handlePurchaseDataChange}
                    style={{
                      padding: "10px",
                      border: "1px solid #d1d3e2",
                      borderRadius: "4px",
                      fontSize: "14px",
                      background: "white",
                    }}
                    required
                  />
                </div>
              </div>
              <div className="row g-2 mb-2">
                <div className="col-md-5">
                  <label
                    className="form-label small fw-medium"
                    style={{ fontSize: "14px" }}
                  >
                    Date <span className="text-danger">*</span>
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    type="date"
                    className={`form-control form-control-sm ${
                      formErrors.purchaseDate ? "border-danger" : ""
                    }`}
                    placeholder="Select Date"
                    name="purchaseDate"
                    value={purchaseData.purchaseDate}
                    onChange={handlePurchaseDataChange}
                    style={{
                      padding: "10px",
                      border: "1px solid #d1d3e2",
                      borderRadius: "4px",
                      fontSize: "14px",
                      background: "white",
                    }}
                    required
                  />
                  {formErrors.purchaseDate && (
                    <div className="text-danger small">
                      {formErrors.purchaseDate}
                    </div>
                  )}
                </div>
              </div>
              <div className="row g-2 mb-2">
                <div className="col-md-5">
                  <label
                    className="form-label small fw-medium"
                    style={{ fontSize: "14px" }}
                  >
                    Dealer Name <span className="text-danger">*</span>
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    type="text"
                    className={`form-control form-control-sm ${
                      formErrors.dealerName ? "border-danger" : ""
                    }`}
                    placeholder="Enter Dealer Name"
                    name="dealerName"
                    value={purchaseData.dealerName}
                    onChange={handlePurchaseDataChange}
                    style={{
                      padding: "10px",
                      border: "1px solid #d1d3e2",
                      borderRadius: "4px",
                      fontSize: "14px",
                      background: "white",
                    }}
                    required
                  />
                  {formErrors.dealerName && (
                    <div className="text-danger small">
                      {formErrors.dealerName}
                    </div>
                  )}
                </div>
              </div>
              <div className="row g-2 mb-2">
                <div className="col-md-5">
                  <label
                    className="form-label small fw-medium"
                    style={{ fontSize: "14px" }}
                  >
                    Mobile No <span className="text-danger">*</span>
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    type="tel"
                    className={`form-control form-control-sm ${
                      formErrors.mobile_no ? "border-danger" : ""
                    }`}
                    placeholder="Enter Mobile No"
                    name="mobile_no"
                    value={purchaseData.mobile_no}
                    onChange={handlePurchaseDataChange}
                    style={{
                      padding: "10px",
                      border: "1px solid #d1d3e2",
                      borderRadius: "4px",
                      fontSize: "14px",
                      background: "white",
                    }}
                    required
                  />
                  {formErrors.mobile_no && (
                    <div className="text-danger small">
                      {formErrors.mobile_no}
                    </div>
                  )}
                </div>
              </div>
              <div className="row g-2 mb-2">
                <div className="col-md-5">
                  <label
                    className="form-label small fw-semibold text-muted"
                    style={{ fontSize: "14px" }}
                  >
                    Sub Total
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    className="form-control form-control-sm bg-light"
                    value={purchaseData.subTotal}
                    name="subTotal"
                    disabled
                    style={{ padding: "8px", fontSize: "14px" }}
                  />
                </div>
              </div>
              <div className="row g-2 mb-2">
                <div className="col-md-5">
                  <label
                    className="form-label small fw-semibold text-muted"
                    style={{ fontSize: "14px" }}
                  >
                    GST Amount
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    className="form-control form-control-sm bg-light"
                    value={purchaseData.gstAmount}
                    name="gstAmount"
                    disabled
                    style={{ padding: "8px", fontSize: "14px" }}
                  />
                </div>
              </div>
              <div className="row g-2 mb-2">
                <div className="col-md-5">
                  <label
                    className="form-label small fw-semibold text-muted"
                    style={{ fontSize: "14px" }}
                  >
                    Net Total
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    className="form-control form-control-sm bg-light"
                    value={purchaseData.netTotal}
                    name="netTotal"
                    disabled
                    style={{ padding: "8px", fontSize: "14px" }}
                  />
                </div>
              </div>
              <div className="row g-2 mb-2">
                <div className="col-md-5">
                  <label
                    className="form-label small fw-semibold text-muted"
                    style={{ fontSize: "14px" }}
                  >
                    Paid Amount
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    className="form-control form-control-sm"
                    name="paidAmount"
                    value={purchaseData.paidAmount}
                    readOnly
                    placeholder="₹0.00"
                    style={{ padding: "8px", fontSize: "14px" }}
                  />
                </div>
              </div>
              <div className="row g-2 mb-2">
                <div className="col-md-5">
                  <label
                    className="form-label small fw-semibold text-muted"
                    style={{ fontSize: "14px" }}
                  >
                    Balance
                  </label>
                </div>
                <div className="col-md-7 d-flex">
                  <input
                    className="form-control form-control-sm bg-light"
                    value={purchaseData.balance}
                    disabled
                    style={{ padding: "8px", fontSize: "14px" }}
                  />
                </div>
              </div>
              <div className="d-flex flex-column flex-md-row gap-1 mt-3">
                <button
                  className="btn btn-success btn-sm ms-2"
                  type="button"
                  onClick={() => setShowPaymentModal(true)}
                >
                  Add payment
                </button>
                <button
                  className="btn btn-success btn-sm btn-custom d-flex align-items-center shadow-sm"
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  Save
                </button>
                <button
                  className="btn btn-danger btn-sm btn-custom d-flex align-items-center shadow-sm"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="card-body bg-opacity-10 p-md-3 mx-4 mt-1"
        style={{ borderRadius: "10px" }}
      >
        <div className="d-flex justify-content-between p-2 p-md-3 mt-2 no-print"></div>
      </div>

      {/* Add Product Modal */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{
          display: showModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content rounded"
            style={{ backgroundColor: "rgb(255, 240, 245)" }}
          >
            <div className="modal-header bg-pink-light border-bottom-0">
              <h5 className="modal-title m-0 fw-semibold">Add Product</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowModal(false)}
                disabled={isLoading}
              ></button>
            </div>
            <div className="modal-body bg-light">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    HSN Code <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={productData.HSN_code}
                    readOnly
                    placeholder="Auto-generated HSN Code"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Category <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={productData.Category}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        Category: e.target.value,
                        Subcategory: "",
                      })
                    }
                    required
                  >
                    <option value="">Select Category</option>
                    {categoryTableData.map((category) => (
                      <option key={category.Category} value={category.Category}>
                        {category.Category}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Subcategory <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={productData.Subcategory}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        Subcategory: e.target.value,
                      })
                    }
                    disabled={!productData.Category}
                    required
                  >
                    <option value="">Select Subcategory</option>
                    {productData.Category &&
                      categoryTableData
                        .find((cat) => cat.Category === productData.Category)
                        ?.SubCategories?.map((subcat) => (
                          <option key={subcat} value={subcat}>
                            {subcat}
                          </option>
                        ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Branch Name
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={productData.branch_name}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        branch_name: e.target.value,
                      })
                    }
                    placeholder="Enter Branch Name"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Brand Name
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={productData.brand_name}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        brand_name: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Brand Name</option>
                    <option value="MRF">MRF</option>
                    <option value="CEAT">CEAT</option>
                    <option value="Apollo">Apollo</option>
                    <option value="JK Tyre">JK Tyre</option>
                    <option value="Bridgestone">Bridgestone</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Type
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={productData.type}
                    onChange={(e) =>
                      setProductData({ ...productData, type: e.target.value })
                    }
                  >
                    <option value="">Select Type</option>
                    <option value="Radial">Radial</option>
                    <option value="Bias">Bias</option>
                    <option value="Tubeless">Tubeless</option>
                    <option value="Tube Type">Tube Type</option>
                    <option value="Solid">Solid</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Tyre Size
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={productData.tyre_size}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        tyre_size: e.target.value,
                      })
                    }
                    placeholder="Enter Tyre Size"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Rate <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    value={productData.rate}
                    onChange={(e) =>
                      setProductData({ ...productData, rate: e.target.value })
                    }
                    placeholder="Enter Rate"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    GST <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    value={productData.gst}
                    onChange={(e) =>
                      setProductData({ ...productData, gst: e.target.value })
                    }
                    placeholder="Enter GST"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    MRP <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    value={productData.Mrp}
                    onChange={(e) =>
                      setProductData({ ...productData, Mrp: e.target.value })
                    }
                    placeholder="Enter MRP"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Product Status
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={productData.status}
                    onChange={(e) =>
                      setProductData({ ...productData, status: e.target.value })
                    }
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="modal-footer border-top-0">
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() => setShowModal(false)}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success"
                onClick={handleProductSubmit}
                disabled={isLoading}
              >
                {isLoading ? "Adding..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Payment Modal */}
      <div
        className={`modal fade ${showPaymentModal ? "show" : ""}`}
        style={{
          display: showPaymentModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      >
        <div className="modal-dialog">
          <div
            className="modal-content"
            style={{ backgroundColor: "rgb(255, 240, 245)" }}
          >
            <div className="modal-header bg-pink-light border-bottom-0">
              <h5 className="modal-title m-0 fw-semibold">Add Payment</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setShowPaymentModal(false);
                  resetPaymentForm();
                }}
              ></button>
            </div>
            <div className="mx-4">
              <div className="row">
                <div className="col-md-5">
                  <label className="form-label fw-medium small">
                    Balance:
                    <input
                      className="form-control form-control-sm mt-1 text-success"
                      value={(
                        Number(purchaseData.netTotal) -
                        Number(purchaseData.paidAmount)
                      ).toFixed(2)}
                      disabled
                    />
                  </label>
                </div>
                <div className="col-md-5">
                  <label className="form-label fw-medium small">
                    Paid:
                    <input
                      className="form-control form-control-sm mt-1 text-success"
                      value={purchaseData.paidAmount}
                      disabled
                    />
                  </label>
                </div>
              </div>
            </div>
            <div className="mx-3 mt-2">
              <div className="row gap-2">
                <div className="col-md-5">
                  <select
                    className="form-select form-select-sm"
                    name="pay_type"
                    value={paymentForm.pay_type}
                    onChange={handlePaymentChange}
                  >
                    <option value="">Select Pay Type</option>
                    <option value="Cash">Cash</option>
                    <option value="Gpay">Gpay</option>
                    <option value="Phonepay">Phonepay</option>
                    <option value="Paytm">Paytm</option>
                    <option value="Credit">Credit</option>
                    <option value="Debit">Debit</option>
                  </select>
                </div>
                <div className="col-md-4">
                  <input
                    className="form-control form-control-sm"
                    name="amount"
                    type="number"
                    value={paymentForm.amount}
                    onChange={handlePaymentChange}
                    placeholder="Enter Amount"
                  />
                </div>
                <div className="col-md-2">
                  <button
                    className="btn btn-success btn-sm"
                    onClick={handleAddPayment}
                  >
                    {paymentEditIndex !== null ? "Update" : "Add"}
                  </button>
                </div>
              </div>
            </div>
            <div className="card mx-3 mt-3 mb-3">
              <div className="d-flex justify-content-center">
                <table className="table table-bordered text-center mx-3 mt-3">
                  <thead className="small fw-light">
                    <tr>
                      <th>S.No</th>
                      <th>Pay Type</th>
                      <th>Amount</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentHistory.map((payment, index) => (
                      <tr key={payment.id}>
                        <td>{index + 1}</td>
                        <td>{payment.pay_type}</td>
                        <td>{payment.amount}</td>
                        <td>
                          <div className="d-flex gap-2 justify-content-center">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() => handleEditPayment(index)}
                            >
                              <Edit2 size={16} />
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleDeletePayment(index)}
                            >
                              <Trash2 size={16} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="d-flex justify-content-end mx-4 mb-3">
              <button
                className="btn btn-success btn-sm"
                onClick={() => {
                  setShowPaymentModal(false);
                  resetPaymentForm();
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPurchases;